import { getCachedAudio } from "./audioCache";

// wavesurfer v7 aborts its in-flight fetch on destroy, rejecting the pending load() promise
const isAbortError = (err) =>
    err?.name === "AbortError" || /aborted/i.test(err?.message || "");

// Instances already torn down, so an in-flight cache lookup cannot load into them
const destroyedInstances = new WeakSet();

// Destroys an instance without letting the abort rejection escape
export const destroyWavesurfer = (instance) => {
    if (!instance) return;
    destroyedInstances.add(instance);
    try {
        instance.unAll();
        instance.destroy();
    } catch (err) {
        if (!isAbortError(err)) console.error("wavesurfer destroy failed:", err);
    }
};

// Runs a load call and swallows the abort rejection caused by an unmount/switch
const runLoad = (load) => {
    try {
        const result = load();
        if (result?.catch) {
            result.catch((err) => {
                if (!isAbortError(err)) console.error("wavesurfer load failed:", err);
            });
        }
    } catch (err) {
        if (!isAbortError(err)) console.error("wavesurfer load failed:", err);
    }
};

// Loads from the audio cache so wavesurfer and the player share a single download
export const loadWavesurfer = (instance, url) => {
    if (!instance || !url) return;

    getCachedAudio(url)
        .then((blob) => {
            if (destroyedInstances.has(instance)) return;
            if (blob) {
                runLoad(() => instance.loadBlob(blob));
            } else {
                runLoad(() => instance.load(url));
            }
        })
        .catch((err) => {
            if (destroyedInstances.has(instance)) return;
            if (!isAbortError(err)) console.error("audio cache fetch failed:", err);
            // Let wavesurfer fetch it itself when the cache download is blocked
            runLoad(() => instance.load(url));
        });
};
